document.addEventListener('DOMContentLoaded', function () {
    $('.more-name li').click(function () {
        console.log($(this).index());
        $(this).addClass('active').siblings().removeClass('active');
        $(`.more-image .img[index=${$(this).index()}]`)
            .show()
            .siblings()
            .hide();
    });
    // 按钮的 Enter 会冒泡到 li；挡住全局 Enter→click，避免切换两次
    $('.more-name li button').on('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        if (event.repeat) return;
        event.stopImmediatePropagation();
    });
});